import { ITextDrawableObject } from "../../../../../../domain/editableFormat/objects";
import { ITextDrawableObjectBean } from "../../../beans/objects";
import { AbstractObjectTranslator } from "../AbstractObjectTranslator";
import { TextAreaStyleTranslator, FontSizeAutoAdjustBehaviorTranslator, LineBreakBehaviorTranslator } from "../properties";
import { TextPresentableObjectTranslator } from "./TextPresentableObjectTranslator";

export class TextDrawableObjectTranslator<TObject extends ITextDrawableObject, TBean extends ITextDrawableObjectBean> extends AbstractObjectTranslator<TObject, TBean> {
  constructor() {
    super(new TextPresentableObjectTranslator());
  }

  overwriteObject(source: TObject, bean: TBean, formatId: number): void {
    source.textStyle = this.textStyle.from(bean);
    source.fontSizeAutoAdjustBehavior = this.fontSizeAutoAdjustBehavior.from(bean);
    source.lineBreakBehavior = this.lineBreakBehavior.from(bean);
  }

  overwriteBean(source: TBean, object: TObject): void {
    const textStyle = this.textStyle.to(object);
    source["@fg"] = textStyle.fg;
    source["@bg"] = textStyle.bg;
    source["@font-name"] = textStyle.fontName;
    source["@font"] = textStyle.font;
    source["@pos"] = textStyle.pos;
    source["@vpos"] = textStyle.vpos;
    source["@auto-size"] = this.fontSizeAutoAdjustBehavior.to(object).autoSize;
    source["@line-break"] = this.lineBreakBehavior.to(object).lineBreak;
  }

  private readonly textStyle = new TextAreaStyleTranslator();
  private readonly fontSizeAutoAdjustBehavior = new FontSizeAutoAdjustBehaviorTranslator();
  private readonly lineBreakBehavior = new LineBreakBehaviorTranslator();
}
